<template>
    <div class="loginIndexVue">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    data(){
        return{
            isChina:false
        }
    },
    created(){
        let language = navigator.language || navigator.userLanguage;
        this.isChina = language == 'zh-CN' ? true : false;
    },
    mounted(){
        var whdef = 100/window.innerWidth;// 表示1920的设计图,使用100PX的默认值
        var wW = window.innerWidth;// 当前窗口的宽度
        var rem = wW * whdef;// 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
        $('html').css('font-size', rem + "px");
    }
}
</script>
<style lang="less">
@import '../assets/css/verticalScreen.less';
body{
    font-size: 0.14rem;
}
.loginIndexVue{
    height: 100%;
    margin: 0 auto;
    background-image: url('../assets/img/visitor_background.jpg');
    background-size: 100%;
}
@media(min-width:1350px){
    .start{
        .content{
            width: 100%;
        }
    }
    .account{
        .content{
            width: 6.2rem;
            padding: 0.6rem;
        }
    }
    
}
@media screen and (min-width:1024px) and (max-width:1350px){
    .start{
        .content{
            width: 100%;
        }
    }
    .account{
        .content{
            width: 5.2rem;
            padding: 0.6rem;
        }
    }
}
@media screen and (min-width:760px) and (max-width:1023px){
    .login{
        width: 100%;
        .btns{
            padding-left: .1rem;
        }
        .start{
            .content{
                width: 100%;
            }
        }
        .account{
            .content{
                padding: 0.3rem;
            }
        }
    }
}
@media(max-width:760px){
    .login{
        width: 100%;
        .btns{
            padding-left: .1rem;
        }
        .start{
            .content{
                width: 100%;
            }
        }
        .account{
            .content{
                width: 90%;
                padding: 0.3rem;
            }
        }
    }
}
</style>